<template>
  <div class="balances-card">
    <div class="card-header">
      <div class="header-content">
        <h3 class="card-title">
          <i class="fas fa-wallet title-icon"></i>
          Saldos
        </h3>
      </div>
    </div>

    <div class="card-content">
      <ErrorsMessages :errors="errors" />

      <b-overlay :show="loading" opacity="0.99" class="loading-overlay">
        <div v-show="data.length == 0" class="no-results">
          <i class="fas fa-inbox no-results-icon"></i>
          <p class="no-results-text">Nenhum saldo encontrado</p>
        </div>

        <div v-show="data.length > 0" class="balances-list">
          <div v-for="(item, key) in data" :key="key" class="balance-item">
            <div class="account-info">
              <div class="account-icon">
                <i class="fas fa-university"></i>
              </div>
              <div class="account-details">
                <span class="account-name">{{ item.account_nickname }}</span>
              </div>
            </div>
            <div class="balance-amount">
              <span
                :class="[
                  'amount-value',
                  parseFloat(item.value) > 0 ? 'positive' : 'negative',
                ]"
              >
                {{ formatMoney(String(item.value)) }}
              </span>
            </div>
          </div>

          <div class="total-balance">
            <div class="total-info">
              <div class="total-icon">
                <i class="fas fa-coins"></i>
              </div>
              <span class="total-label">Saldo Total</span>
            </div>
            <div class="total-amount">
              <span class="total-value">
                {{ formatMoney(String(total)) }}
              </span>
            </div>
          </div>
        </div>
      </b-overlay>
    </div>
  </div>
</template>

<script>
import ErrorsMessages from "../../Components/ErrorsMessages";
import api from "../../../services/api";
import { formatMoney } from "../../../lib/format";

export default {
  name: "Balances",
  components: {
    ErrorsMessages,
  },
  data() {
    return {
      data: [],
      total: 0,
      errors: [],
      loading: false,
    };
  },
  created() {
    this.retrieve();
  },
  methods: {
    formatMoney,
    async retrieve() {
      try {
        this.loading = true;

        const response = await api.get(
          "/rest-home/financial/overview/balances"
        );

        const { data, total } = response.data;

        this.data = data;
        this.total = total;

        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>

<style scoped>
.balances-card {
  background: white;
  border-radius: 16px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.2);
  overflow: hidden;
  height: fit-content;
}

.card-header {
  background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);
  padding: 20px 24px;
  border-bottom: 1px solid #e5e7eb;
}

.header-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.card-title {
  font-size: 18px;
  font-weight: 600;
  color: #1e293b;
  margin: 0;
  display: flex;
  align-items: center;
  font-family: "WorkSans-SemiBold", sans-serif;
}

.title-icon {
  color: #0f65b0;
  margin-right: 8px;
  font-size: 16px;
}

.card-content {
  padding: 24px;
}

.loading-overlay {
  border-radius: 12px;
  min-height: 200px;
}

.no-results {
  text-align: center;
  padding: 40px 24px;
  color: #6b7280;
}

.no-results-icon {
  font-size: 48px;
  color: #d1d5db;
  margin-bottom: 16px;
}

.no-results-text {
  font-size: 16px;
  color: #6b7280;
  margin: 0;
}

.balances-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.balance-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px;
  background: #f8fafc;
  border-radius: 12px;
  border: 1px solid #e5e7eb;
  transition: all 0.3s ease;
}

.balance-item:hover {
  background: #f1f5f9;
  border-color: #cbd5e1;
  transform: translateY(-1px);
}

.account-info {
  display: flex;
  align-items: center;
  gap: 12px;
}

.account-icon {
  width: 40px;
  height: 40px;
  background: linear-gradient(135deg, #0f65b0 0%, #1e40af 100%);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 14px;
}

.account-details {
  max-width: 70% !important;
}

.account-name {
  font-weight: 500;
  color: #1e293b;
  font-size: 14px;
}

.balance-amount {
  display: flex;
  align-items: center;
}

.amount-value {
  font-weight: 600;
  font-size: 16px;
}

.amount-value.positive {
  color: #10b981;
}

.amount-value.negative {
  color: #ef4444;
}

.total-balance {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px;
  background: linear-gradient(135deg, #0f65b0 0%, #1e40af 100%);
  border-radius: 12px;
  margin-top: 16px;
  color: white;
}

.total-info {
  display: flex;
  align-items: center;
  gap: 12px;
}

.total-icon {
  width: 40px;
  height: 40px;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
}

.total-label {
  font-weight: 600;
  font-size: 16px;
}

.total-value {
  font-weight: 700;
  font-size: 18px;
}

@media (max-width: 768px) {
  .card-content {
    padding: 16px;
  }

  .balance-item {
    padding: 12px;
  }

  .total-balance {
    padding: 16px;
  }

  .account-icon,
  .total-icon {
    width: 36px;
    height: 36px;
  }

  .amount-value {
    font-size: 14px;
  }

  .total-value {
    font-size: 16px;
  }
}
</style>